<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Schedule Reports">
      <v-card-actions>
        <router-link slot="right" :to="{ name: 'B2SReportDashboard' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="2" class="mr-n2 mt-2" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <v-card-text class="pt-0 pr-1">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }"
        :items-per-page="10"
        :headers="headers"
        :items="items"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn @click="download(item.s3URL)" v-if="item.status === 'Completed'" class="px-2 ml-1 white--text ma-1" color="primary" min-width="0" small>
            <v-icon small> mdi-download</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
export default {
  components: { MaterialCard },
  name: 'B2SReportDownload',
  data () {
    return {
      loadingComponent: null,
      items: [],
      search: '',
      headers: [
        { text: 'Sr.No', sortable: false, value: 'srno' },
        { text: 'Report Name', sortable: true, value: 'name' },
        { text: 'Type', sortable: true, value: 'type' },
        { text: 'Status', sortable: true, value: 'status' },
        { text: 'created At', value: 'createdAt', sortable: false },
        { text: 'Download', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },
  async created () {
    await this.getReportList()
  },
  methods: {
    getReportList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/cronReport/get-cron-report`)
        this.items = response.data
        this.items.forEach((el, index) => {
          el.srno = index + 1
          el.createdAt = moment(el.createdAt).format('DD-MM-YYYY')
          // el.updatedAt = moment(el.updatedAt).format('DD-MM-YYYY')
        })
        console.log('data--', this.items)
        this.loadingComponent.close()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        return this.errMsg(errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    download: async function (key) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let url = await http.get(`${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`)

        window.open(url.data)
        this.loadingComponent.close()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
